// extracted by mini-css-extract-plugin
export var cardSelected = "_ht-2";
export var image = "_ht-1";
export var table = "_ht-0";